module.exports = __webpack_public_path__ + "static/img/four.dc2477e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elephant/four.png
// module id = gRwe
// module chunks = 1